import Cookies from "js-cookie";

export function isAuthenticated() {
  return !!Cookies.get("user");
}

export function getUser() {
  const user = Cookies.get("user");
  return user ? JSON.parse(user) : null;
}
